export const GET_GENERAL_STATS = 'GET_GENERAL_STATS';
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const GET_DEPOSIT_DETAILS = 'GET_DEPOSIT_DETAILS';
export const GENERATE_REPORTS = 'GENERATE_REPORTS';
export const GET_REPORT_DETAILS = 'GET_REPORT_DETAILS';
export const DOWNLOAN_GENERATED_REPORT = 'DOWNLOAN_GENERATED_REPORT';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_BULK_FILTERS = 'SET_BULK_FILTERS';